module.exports = __webpack_public_path__ + "media/assets/airtutors_banner-6936d76a97770319b053bb0b2f35c117.png";